import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { FaArrowLeft } from 'react-icons/fa';
import { getFirebase } from '@services/firebase';
import { readGlobalProfiles } from '@services/firebaseGlobal';
import { useAlert } from '../contexts/ToastContext';

const Support = ({ userRole: propUserRole }) => {
  const { auth } = getFirebase();
  const showAlert = useAlert();
  const [user, loading, error] = useAuthState(auth);
  const [supportData, setSupportData] = useState([]);
  const [userRole, setUserRole] = useState(() => {
    if (propUserRole) return propUserRole;
    try {
      const cachedRole = localStorage.getItem('userRole');
      return cachedRole || '';
    } catch (err) {
      console.error('Error reading userRole from localStorage:', err);
      return '';
    }
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        try {
          const userList = await readGlobalProfiles('cUsers');
          const currentUserData = userList.find(userData => userData.id === user.uid);
          if (currentUserData) {
            let role = 'User';
            if (currentUserData.isadminuser) {
              role = 'Admin';
            } else if (currentUserData.issuperuser) {
              role = 'Super';
            }
            setUserRole(role);
            try {
              localStorage.setItem('userRole', role);
            } catch (err) {
              console.error('Error saving userRole to localStorage:', err);
            }
          } else {
            showAlert('Access denied: User data not found.');
            navigate('/profile');
          }
        } catch (err) {
          console.error('Error fetching user role:', err);
          showAlert('Error fetching user role. Please try again.');
          navigate('/profile');
        }
      }
    };

    if (!propUserRole) {
      fetchUserRole();
    } else if (propUserRole) {
      navigate('/profile');
    }
  }, [user, navigate, propUserRole]);

  useEffect(() => {
    const fetchSupportData = async () => {
      if (userRole === 'Admin' || userRole === 'Super') {
        try {
          // Placeholder for fetching support data
          const data = await readGlobalProfiles('support'); // Adjust based on your Firestore structure
          setSupportData(data || []);
        } catch (err) {
          console.error('Error fetching support data:', err);
        }
      }
    };

    fetchSupportData();
  }, [userRole]);

  const handleBack = () => {
    navigate('/profile');
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!user) return <div>Please log in to access this page.</div>;
  if (userRole !== 'Admin' && userRole !== 'Super') return null;

  return (
    <div className="profile-page support-page">
      <div className="profile-header">
        <button className="back-btn" onClick={handleBack}>
          <FaArrowLeft />
        </button>
      </div>
      <div className="nav-card">
        <div className="support-content">
          {supportData.length > 0 ? (
            <div>
              {supportData.map(data => (
                <div key={data.id}>
                  {/* Display support data */}
                  <p>{JSON.stringify(data)}</p>
                </div>
              ))}
            </div>
          ) : (
            <p>No support data available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Support;